const LOAD_COMPONENT_MODULE_PROVIDERS = [];

export {LOAD_COMPONENT_MODULE_PROVIDERS};
